const LeftIcon = () => {
  return (
    <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6 12.0002L0 6.00024L6 0.000244141L7.4 1.40024L2.8 6.00024L7.4 10.6002L6 12.0002Z"
        fill="#6E6E6E"
      />
    </svg>
  );
};

export default LeftIcon;
